export default __webpack_public_path__ + "static/media/school2.74e24299.png";